import { useContext, useEffect } from 'react';
import {
  generatePath,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch
} from 'react-router-dom';

import Panel from 'components/panel/Panel';
import Loader from 'components/loader/Loader';

import { getLocalDateFormat } from 'utils/date';
import {
  ROUTE_USER_REPORTS_ENTITY_REPORT_TESTS_TESTDATA,
  ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA,
  ROUTE_USER_REPORTS_ENTITY_REPORT,
  ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT
} from 'routes/RouteList';
import usePostMessage from 'hooks/utils/usePostMessage';
import ReportCard from 'containers/partials/cards/ReportCard';
import { useSessionContext } from 'contexts/SessionContext';
import { StoreContext } from 'index';
import { useTestDataContext } from 'contexts/TestDataContext';

const Report = () => {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { push } = useHistory();
  let location = useLocation();
  const { entityId, sessionId, testDataId } = useParams();
  const { session, sessionLoading } = useSessionContext();
  const {
    testData,
    fetchTestData,
    testDataLoading,
    activeDate,
    unsetAllData,
    setNewActiveDate
  } = useTestDataContext();
  const active = useRouteMatch([
    ROUTE_USER_REPORTS_ENTITY_REPORT,
    ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA
  ]);
  const isSessionRootView = useRouteMatch({
    path: ROUTE_USER_REPORTS_ENTITY_REPORT,
    strict: true,
    exact: true
  });
  const isReportView = useRouteMatch({
    path: [
      ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT,
      ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA
    ],
    strict: true
  });

  const { sendMessage } = usePostMessage();

  useEffect(() => {
    if (session?.id !== sessionId) return;

    if ((!testDataId && session && isReportView) || isSessionRootView) {
      let testData;
      if (session.isRecurring) {
        if (!activeDate) {
          const today = new Date();
          setNewActiveDate(today);
          testData = session.getTestDataByDate(user.id, today);
        } else {
          testData = session.getTestDataByDate(user.id, activeDate);
        }
      } else {
        testData = session.getLastTestData(user.id);
      }
      if (testData?.id) {
        const selectedPath = !session.isRecurring
          ? ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA
          : testData.finishedPercentage > 0
            ? ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA
            : ROUTE_USER_REPORTS_ENTITY_REPORT_TESTS_TESTDATA;

        push(
          generatePath(selectedPath, {
            entityId,
            sessionId,
            testDataId: testData.id
          })
        );
      } else {
        unsetAllData();
      }
    } else if (testDataId && session && isReportView) {
      if (!testData.id || testData.id !== testDataId) {
        fetchTestData(session.id, testDataId);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testDataId, session, location]);

  useEffect(() => {
    const data = {
      title: session?.name,
      description: getLocalDateFormat(session.startdate),
      canGoBack: true
    };
    sendMessage({ message: data });
  }, [sessionLoading, session]);

  if (sessionLoading || testDataLoading) {
    return (
      <Panel active={active?.isExact}>
        <Loader />
      </Panel>
    );
  }
  return (
    <Panel active={active?.isExact}>
      {session && (
        <ReportCard
          compressed
          rootPath={generatePath(ROUTE_USER_REPORTS_ENTITY_REPORT, {
            entityId,
            sessionId
          })}
        />
      )}
    </Panel>
  );
};

export default Report;
